<template>
  <div class="applyPopup">
    <mt-header title="发送申请意向">
      <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="content">
      <div class="title">
        <h1>{{project.title}}</h1>
        <span>项目预算：{{project.prepriceName}}</span> 
      </div>
      <div class="money">
        <span>您的报价是？</span>
        <input v-model="number" type="number" maxlength= '9'>
      </div>
      <div class="describe">
        <button type="button" @click="shwoDescribePopup">意向怎么写？<icon name='info-circle'></icon></button>
        <p>说说你对项目的理解和申请意向</p>
        <p>(1000字以内)</p>
        <textarea v-model="content" rows="10"></textarea>
      </div>


    <p id="serviceFee">

    </p>

      <div class="selsect">
        <input type="checkbox" name="checked" checked='checked'  id="ch">
        <label for="checked" >如果项目成交则默认同意签署<span @click="shwoContractPopup">云智图三方服务合同</span></label>
      </div>
    </div>
    <div class="btn" v-on:click="sendapply">发送申请</div>
    <mt-popup v-model="describePopup" position="right" class="popup">
      <mt-header title="项目报价申请意向填写示例">
        <mt-button icon="back" slot="left" @click="hidenDescribePopup">返回</mt-button>
      </mt-header>
      <div ref='example' class="example" ></div>
    </mt-popup>
    <mt-popup v-model="contractPopup" position="right" class="popup">
      <mt-header title="云智图第三方合同">
        <mt-button icon="back" slot="left" @click="hidenContractPopup">返回</mt-button>
      </mt-header>
      <p>云智图第三方合作合同</p>
      <div  ref='contract' class="contract"></div>
    </mt-popup>
  </div>
</template>

<script>
import {Toast, Indicator} from 'mint-ui'
import qs from 'qs'
export default {
  name: 'applyPopup',
  data () {
    return {
      project: '',
      number: '',
      content: '',
      data: '',
      items: '',
      projectid: '',
      accountid: '',
      projectType: '',
      projectOffer: '',
      describePopup: false,
      contractPopup: false,
    }
  },
  mounted () {
    // 初始化加载区
    this.projectData()
    this.applydemo()
    this.contract()
    this.getFee()
  },
  methods: {
    shwoDescribePopup: function () {
      this.describePopup = true
    },
    hidenDescribePopup: function () {
      this.describePopup = false
    },
    shwoContractPopup: function () {
      this.contractPopup = true
    },
    hidenContractPopup: function () {
      this.contractPopup = false
    },
    projectData: function () {
      console.log('我是申请意向')
      this.projectid = this.$route.query.projectid
      let _this = this
      this.axios.get('url/work/project/queryweixinproject?id=' + this.projectid + '')
      .then(function (res) {
        _this.project = res.data
        console.log(res)
      })
    },


// 获取费率
    getFee: function(){
             this.projectid = this.$route.query.projectid
             
             this.axios.get('url/work/project/getServiceFee?id='+this.projectid)
             .then(function(fee){
              console.log(fee.data)            
              var feeRate=document.getElementById("serviceFee");      
             feeRate.innerHTML= '<a style="font-size: 13px;color: black">平台服务费：项目金额*' + fee.data + '%</a><a style="font-size: 12px ; font-weight: 200; color: gray; ">&nbsp;(项目完成后，收取您项目金额的' + fee.data + '%作为平台服务费)</a>'
    })
    },

    // 申请意向实例
    applydemo: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: 'http://blog.yunzhitu.com/apply-sample/feed/json',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        _this.$refs.example.innerHTML = res.data.items[0].content_html
        console.log(_this.items)
      })
    },
     // 云智图第三方合同
    contract: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: 'http://blog.yunzhitu.com/contract/feed/json ',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        _this.$refs.contract.innerHTML = res.data.items[0].content_html
        console.log(_this.items)
      })
    },



    // 发送申请
    sendapply () {
      let _this = this
      console.log(_this.content)
      console.log(_this.number)
      if (_this.number === null || _this.number === '') {
        Toast({
          message: '填写金额不能为空',
          position: 'middle',
          duration: 1000
        })
      } else if (_this.content === null || _this.content === '') {
        Toast({
          message: '申请意向不能为空',
          position: 'middle',
          duration: 1000
        })
      } else {
        if (_this.number.length > 9) {
          Toast({
            message: '金额不能超过9位',
            position: 'middle',
            duration: 1000
          })
        }else if(_this.number.indexOf(".")>-1){
          Toast({
            message: '报价需要输入整数',
            position: 'middle',
            duration: 1000
          })
        } else if(_this.number<=0){
          Toast({
            message: '您的报价需大于0元',
            position: 'middle',
            duration: 1000
          })
        }
        else if(document.getElementById('ch').checked==false){
         Toast({
            message: '请勾选并同意云智图三方服务合同',
            position: 'middle',
            duration: 1000
          })
        }
         else {
          Indicator.open({
            text: '加载中...',
            spinnerType: 'fading-circle'
          })
          _this.projectOffer = {
            content: _this.content,
            price: _this.number,
            projectId: _this.project.id,
            supplierId: this.STATE.state.loginId
          }
          console.log(qs.stringify({
              content: _this.content,
              price: _this.number,
              projectId: _this.project.id,
              supplierId: this.STATE.state.loginId
            }))
          this.axios({
            method: 'post',
            url: 'url/work/project/saveprojectoffer',
            data:qs.stringify({
              content: _this.content,
              price: _this.number,
              projectId: _this.project.id,
              supplierId: this.STATE.state.loginId
            })
          }).then(function (res) {
            _this.data = res.data
            if (_this.data.success === true) {
              Indicator.close()
              _this.$router.push({path: '/project/projectApplyPopup/applySuccess', query: { projectid: _this.project.id }})
            }
            if (_this.data.msg !== null) {
              Indicator.close()
              Toast({
                message: _this.data.msg,
                position: 'middle',
                duration: 1000
              })
            }
            console.log(res)
          }).catch(function (response) {
            Indicator.close()
          })
        }
      }
    }
  }
}
</script>




<style scoped>
.content{
  padding: 20px 18px;
}
.title h1{
  font-size: 18px;
}
.title span{
  font-size: 12px;
  color: #727272;
}
.money{
  display: table;
  width: 100%;
  margin:30px 0 15px;
}
.money span{
  display: table-cell;
  width: 95px;
  font-size: 15px;
  color: #108ee9;
}
.money input{
  display: table-cell;
  width: 100%;
  border: none;
  border-bottom: 1px solid #d6d6d6;
  outline: none;
}
.describe p{
  font-size: 12px;
  color: #727272;
}
.describe button{
  background-color:#108EE9;
  font-size: 12px;
  color: #fff;
  float: right;
  border: none;
  outline: none;
  border-radius: 5px;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
}
.describe .fa-icon{
  vertical-align: bottom;
  transform: scale(0.9)
}
.describe textarea{
  margin-top: 15px;
  width: 100%;
  resize: none;
  border:1px solid #d6d6d6;
  border-radius: 5px;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
  font-size: 12px;
  padding: 5px;
  box-sizing: border-box;
}
.selsect{
  text-align: center;
}
.selsect input{
  vertical-align: middle;
}
.selsect label{
  font-size: 12px;
  color: #777;
  vertical-align: middle;
}
.selsect label span{
  color: #45a0ec;
  text-decoration: underline;
}
.btn{
  width: 100%;
  line-height: 50px;
  text-align: center;
  background-color:#108ee9;
  color: #fff;
  margin-bottom: 60px;
}
.popup{
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.popup pre{
  padding: 14px;
  font-size: 12px;
}
.example{
  padding: 14px;
}
.popup p{
  text-align: center;
  margin: 10px 0 0;
}
</style>


// WEBPACK FOOTER //
// projectApplyPopup.vue?2d449387